import { useState } from 'react';
import ScheduleCallBack from './Popup/ScheduleACallBack';
import BookVideoConsultation from './Popup/BookVideoConsultation';

function ContactDetailCard() {
    const [showScheduleCallModal, setShowScheduleCallModal] = useState(false);
    const [showVideoConsultationModal, setShowVideoConsultationModal] = useState(false);

    const handleScheduleCallClick = () => {
        setShowScheduleCallModal(true);
    };

    const closeScheduleCallModal = () => {
        setShowScheduleCallModal(false);
    };

    const handleVideoConsultationClick = () => {
        setShowVideoConsultationModal(true);
    };

    const closeVideoConsultationModal = () => {
        setShowVideoConsultationModal(false);
    };

    return (
        <div className="bg-[#F7F7F7] p-4 rounded-lg shadow-md w-full mx-auto">
            <div className="text-2xl font-semibold mb-2 md:hidden lg:hidden lgx2:hidden">Got Any Questions?</div>
            {/* Grid layout with image on the left and content on the right */}
            <div className="md:grid md:grid-cols-2 md:items-center md:gap-4">
                <img src="/featureIcons/Decision.svg" alt="Any Questions" className="mb-4 md:w-6/12 w-9/12 mx-auto hidden md:block lg:block lgx2:block" width="300" height="200" />
                <div>
                    <div className="text-2xl font-semibold mb-2 hidden md:block lg:block lgx2:block">Got Any Questions?</div>
                    <div className="text-base mb-4 hidden md:block lg:block lgx2:block">Feel free to ask us anything—we're here to assist and guide you every step of the way!</div>
                    {/* Buttons are now centered within the right column */}
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-2 items-center md:items-start">
                        <div>
                            <button className="customButton" onClick={handleScheduleCallClick}>
                                <div className="svg-wrapper-1">
                                    <div className="svg-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58z" />
                                        </svg>
                                    </div>
                                </div>
                                <span>Schedule a Callback</span>
                            </button>
                        </div>
                        <div>
                            <button className="customButton" onClick={handleVideoConsultationClick}>
                                <div className="svg-wrapper-1">
                                    <div className="svg-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-camera-video" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556zM2 4 a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z" />
                                        </svg>
                                    </div>
                                </div>
                                <span>Book Video Consultation</span>
                            </button>
                            <div className="text-sm italic mt-1">*Recommended for first-time travelers</div>
                        </div>
                    </div>
                    {showScheduleCallModal && <ScheduleCallBack closeModal={closeScheduleCallModal} />}
                    {showVideoConsultationModal && <BookVideoConsultation closeModal={closeVideoConsultationModal} />}
                </div>
            </div>
        </div>
    );
}

export default ContactDetailCard;